import React from 'react';
import { Image } from 'antd';
import styled from 'styled-components';
import AuthenticationDialogComponent from '../authentication-flow/sign-in-flow.dialog';
import { Col, Row } from 'antd';

const CarSignUpBanner: React.FC = () => {
  return (
    <StyledSection>
      <Row gutter={[8, 8]}>
        <Col md={12} xs={24}>
          <TripImage src="/trip_icon.svg" preview={false} />
        </Col>
        <Col md={12} xs={24}>
          <StyledTextSection>
            <StyledH2>Members access great rates and savings</StyledH2>
            <StyledH4>Sign up for access to personalized recommendations and Private Deals.</StyledH4>
            <AuthenticationDialogComponent
              initialDialogState={'sign-up'}
              buttonText={'Join Now'}
              buttonType={'primary'}
            />
          </StyledTextSection>
        </Col>
      </Row>
    </StyledSection>
  );
};

export default CarSignUpBanner;

const StyledSection = styled.div`
  background-color: #f5f6f8;
  display: flex;
  justify-content: space-between;
  padding: 25px;
  margin-bottom: 20px;
`;

const TripImage = styled(Image)`
  display: flex;
`;

const StyledH2 = styled.h2`
  text-align: left;
  margin-top: 25px;
  margin-bottom: 20px;
`;
const StyledH4 = styled.h4`
  text-align: left;
  margin-bottom: 40px;
`;
const StyledTextSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
